import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { CopyButton } from "@/components/shared/copy-button"
import { AlertTriangle } from "lucide-react"

interface ApiKeyCreatedDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  rawKey: string
}

export function ApiKeyCreatedDialog({ open, onOpenChange, rawKey }: ApiKeyCreatedDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>API Key Created</DialogTitle>
          <DialogDescription>
            Copy your API key now. You won't be able to see it again.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="flex items-start gap-2 rounded-lg border border-amber-500/30 bg-amber-500/5 p-3">
            <AlertTriangle className="h-4 w-4 text-amber-500 mt-0.5 shrink-0" />
            <p className="text-sm text-amber-200/80">
              This is the only time your API key will be displayed. Store it securely.
            </p>
          </div>

          <div className="flex items-center gap-2 rounded-lg glass-card p-3">
            <code className="flex-1 text-sm font-mono break-all select-all">{rawKey}</code>
            <CopyButton text={rawKey} />
          </div>

          <div className="flex justify-end">
            <Button onClick={() => onOpenChange(false)}>Done</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
